var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tabs-nav', {flex: _vm.flex}]},[_c('ul',{staticClass:"nav nav-tabs nav-fill",attrs:{"role":"tablist"}},[_vm._t("items")],2),_c('div',{staticClass:"tab-content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }